import { render } from "./Weight.svg?vue&type=template&id=00508571"
const script = {}
script.render = render

export default script